import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-report',
    templateUrl: './report-template.component.html',
    styleUrls: ['./report-template.component.scss'],
    standalone: false
})
export class ReportTemplateComponent implements OnInit {

  showLeftPanel: boolean = true;
  showTreeEditor: boolean = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.showTreeEditor = this.router.url.toString().includes("treeeditor");
  }

}
